<template>
  <el-card id="ysMonitorId" class="ys-monitor-wrapper flex-1 h-full" :body-style="{ height: '100%' }">
    <div class="flex flex-col h-full">
      <TitleBorder title="实时监控画面" v-if="!isFullScreen"></TitleBorder>

      <!-- 一、四、九宫格 -->
      <div class="flex-1 mb-10px" :class="gridClass" v-if="monitorNum !== 6">
        <div class="grid-item" :class="{'select-grid-item': curPlayIndex === index}" v-for="(item, index) in monitorList" :key="index" @click="setCurVideoIndex(index)">
          <div class="h-full" v-if="item.code">
            <DHWSPlayer :ref="'ws-player' + '-' + item.id +'-' + index"
                        :code="item.code"
                        :externalId="item.externalId" :id="item.id" :currentIndex="curPlayIndex"></DHWSPlayer>
          </div>
          <MonitorEmpty v-else></MonitorEmpty>
        </div>
      </div>

      <!-- 六宫格 -->
      <div class="flex-1 mb-10px six-grid-box" v-if="monitorNum === 6">
        <div class="grid-top">
          <div class="grid-left" :class="{'select-grid-item': curPlayIndex === 0}" @click="setCurVideoIndex(0)">
            <div class="h-full" v-if="monitorList6[0].code">
              <DHWSPlayer :ref="'ws-player' + '-' + item.id + '-' + index"
                          :externalId="item.externalId"
                          :code="monitorList6[0].code"
                          :id="monitorList6[0].id" :currentIndex="curPlayIndex"></DHWSPlayer>
            </div>
            <MonitorEmpty v-else></MonitorEmpty>
          </div>
          <div class="grid-right">
            <div class="grid-item" :class="{'select-grid-item': curPlayIndex === 1}" @click="setCurVideoIndex(1)">
              <div class="h-full" v-if="monitorList6[1].code">
                <DHWSPlayer :ref="'ws-player' + '-' + item.id + '-' + index"
                            :externalId="item.externalId"
                            :code="monitorList6[1].code"
                            :id="monitorList6[1].id" :currentIndex="curPlayIndex"></DHWSPlayer>
              </div>
              <MonitorEmpty v-else></MonitorEmpty>
            </div>
            <div class="grid-item" :class="{'select-grid-item': curPlayIndex === 2}" @click="setCurVideoIndex(2)">
              <div class="h-full" v-if="monitorList6[2].code">
                <DHWSPlayer :ref="'ws-player' + '-' + item.id + '-' + index"
                            :externalId="item.externalId"
                            :code="monitorList6[2].code"
                            :id="monitorList6[2].id" :currentIndex="curPlayIndex"></DHWSPlayer>
              </div>
              <MonitorEmpty v-else></MonitorEmpty>
            </div>
          </div>
        </div>

        <div class="grid-bottom">
          <div class="grid-item" :class="{'select-grid-item': curPlayIndex === 3}" @click="setCurVideoIndex(3)">
            <div class="h-full" v-if="monitorList6[3].code">
              <DHWSPlayer :ref="'ws-player' + '-' + item.id + '-' + index"
                          :externalId="item.externalId"
                          :code="monitorList6[3].code"
                          :id="monitorList6[3].id" :currentIndex="curPlayIndex"></DHWSPlayer>
            </div>
            <MonitorEmpty v-else></MonitorEmpty>
          </div>
          <div class="grid-item" :class="{'select-grid-item': curPlayIndex === 4}" @click="setCurVideoIndex(4)">
            <div class="h-full" v-if="monitorList6[4].code">
              <DHWSPlayer :ref="'ws-player' + '-' + item.id + '-' + index"
                          :externalId="item.externalId"
                          :code="monitorList6[4].code"
                          :id="monitorList6[4].id" :currentIndex="curPlayIndex"></DHWSPlayer>
            </div>
            <MonitorEmpty v-else></MonitorEmpty>
          </div>
          <div class="grid-item" :class="{'select-grid-item': curPlayIndex === 5}" @click="setCurVideoIndex(5)">
            <div class="h-full" v-if="monitorList6[5].code">
              <DHWSPlayer :ref="'ws-player' + '-' + item.id + '-' + index"
                          :externalId="item.externalId"
                          :code="monitorList6[5].code"
                          :id="monitorList6[5].id"
                          :currentIndex="curPlayIndex"></DHWSPlayer>
            </div>
            <MonitorEmpty v-else></MonitorEmpty>
          </div>
        </div>
      </div>

      <!-- 底部工具栏 -->
      <!-- <div class="bottom-btns">
        <div class="icon-item">
          <img @click="minHandle" v-if="isFullScreen" src="@/assets/images/video-monitor/max-select.png"/>
          <img @click="maxHandle" v-else src="@/assets/images/video-monitor/max.png"/>
        </div>
        <div class="icon-item" @click="gridShowHandle(1)">
          <img v-if="monitorNum === 1" src="@/assets/images/video-monitor/one-grid-select.png"/>
          <img v-else src="@/assets/images/video-monitor/one-grid.png"/>
        </div>
        <div class="icon-item" @click="gridShowHandle(4)">
          <img v-if="monitorNum === 4" src="@/assets/images/video-monitor/four-grid-select.png"/>
          <img v-else src="@/assets/images/video-monitor/four-grid.png"/>
        </div>
        <div class="icon-item" @click="gridShowHandle(6)">
          <img v-if="monitorNum === 6" src="@/assets/images/video-monitor/six-grid-select.png"/>
          <img v-else src="@/assets/images/video-monitor/six-grid.png"/>
        </div>
        <div class="icon-item" @click="gridShowHandle(9)">
          <img v-if="monitorNum === 9" src="@/assets/images/video-monitor/nine-grid-select.png"/>
          <img v-else src="@/assets/images/video-monitor/nine-grid.png"/>
        </div>
      </div> -->
    </div>
  </el-card>
</template>

<script>
import DHWSPlayer from '@/components/video/DHPlayer/DHWSPlayer'
import TitleBorder from '@/components/TitleBorder'
import MonitorEmpty from './MonitorEmpty'

export default {
  name: 'ysMonitor',
  components: {
    MonitorEmpty,
    DHWSPlayer,
    TitleBorder
  },
  data() {
    return {
      monitorNum: 1, // 有几个窗口
      isFullScreen: false,
      monitorList6: [{}, {}, {}, {}, {}, {}],
      monitorList: [{}],
      curPlayIndex: 0 // 窗口号
    }
  },
  computed: {
    gridClass() {
      const num = this.monitorNum
      if (num === 1) {
        return 'one-grid-box'
      } if (num === 4) {
        return 'four-grid-box'
      } if (num === 9) {
        return 'nine-grid-box'
      }
      return ''
    }
  },
  methods: {
    playVideo(info) {
      const playerEl = `ws-player-${info.id}-${this.curPlayIndex}`
      this.$nextTick(() => {
        console.log('info', info, this.$refs, this.$refs[playerEl])
        // 创建播放器
        this.$refs[playerEl][0].realPlayer(playerEl)
      })
      if (this.monitorNum === 6) {
        this.$set(this.monitorList6, this.curPlayIndex, info)
        // console.log(this.monitorList6, 'monitorList6')
      } else {
        this.$set(this.monitorList, this.curPlayIndex, info)
        // console.log(this.monitorList, 'monitorList')
      }
    },
    setCurVideoIndex(index) {
      this.curPlayIndex = index
    },
    gridShowHandle(num) {
      this.curPlayIndex = 0
      this.monitorNum = num
      if (num === 1) {
        this.monitorList = [{}]
      } else if (num === 4) {
        this.monitorList = [{}, {}, {}, {}]
      } else if (num === 9) {
        this.monitorList = [{}, {}, {}, {}, {}, {}, {}, {}, {}]
      } else if (num === 6) {
        this.monitorList6 = [{}, {}, {}, {}, {}, {}]
      }
    },
    maxHandle() {
      this.isFullScreen = true
      const dom = document.getElementById('ysMonitorId')
      dom.requestFullscreen()
    },
    minHandle() {
      this.isFullScreen = false
      document.exitFullscreen && document.exitFullscreen()
    }
  },
  mounted() {
    document.addEventListener('fullscreenchange', () => {
      if (!document.fullscreenElement) {
        this.isFullScreen = false
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.ys-monitor-wrapper {
  .select-grid-item {
    border: 1px solid var(--systemMainColor) !important;
  }

  .one-grid-box {
    background: var(--collapseHeadHeaderBg);

    .grid-item {
      height: 100%;
      border: 1px solid transparent;
    }
  }

  .four-grid-box {
    display: flex;
    flex-wrap: wrap;

    .grid-item {
      margin-right: 10px;
      margin-bottom: 10px;
      width: calc(50% - 5px);
      height: calc(50% - 5px);
      background: var(--collapseHeadHeaderBg);
      border: 1px solid transparent;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }

  .six-grid-box {
    display: flex;
    flex-direction: column;

    .grid-top {
      flex: 1;
      display: flex;

      .grid-left {
        flex: 1;
        margin-right: 10px;
        margin-bottom: 10px;
        background: var(--collapseHeadHeaderBg);
        border: 1px solid transparent;
      }

      .grid-right {
        margin-bottom: 10px;
        width: calc((100% / 3) - 7.5px);

        .grid-item {
          height: calc(50% - 5px);
          background: var(--collapseHeadHeaderBg);
          border: 1px solid transparent;

          &:first-child {
            margin-bottom: 10px;
          }
        }
      }
    }

    .grid-bottom {
      display: flex;
      height: calc((100% / 3) - 7.5px);

      .grid-item {
        margin-right: 10px;
        flex: 1;
        background: var(--collapseHeadHeaderBg);
        border: 1px solid transparent;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .nine-grid-box {
    display: flex;
    flex-wrap: wrap;

    .grid-item {
      margin-right: 10px;
      margin-bottom: 10px;
      width: calc((100% / 3) - 7.5px);
      height: calc((100% / 3) - 7.5px);
      background: var(--collapseHeadHeaderBg);
      border: 1px solid transparent;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }

  .bottom-btns {
    display: flex;
    justify-content: center;
    align-items: center;

    .icon-item {
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>
